/**
 * Starts a download without opening a tab. Cross-origin URLs must respond with
 * Content-Disposition: attachment; the server also supplies the filename.
 */
export const downloadUrl = (url: string): void => {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_self";
  link.rel = "noreferrer";
  link.download = "";
  link.hidden = true;
  document.body.append(link);
  try {
    link.click();
  } finally {
    link.remove();
  }
};

/**
 * Downloads a blob as a file with the specified filename
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();

  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

/**
 * Downloads CSV data as a file with a timestamped filename
 */
export const downloadCsvBlob = (blob: Blob, baseFilename: string = "data"): void => {
  const timestamp = new Date().toLocaleDateString();
  const filename = `${baseFilename}-${timestamp}.csv`;
  downloadBlob(blob, filename);
};
